<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300" (click)="closeDropdowns()">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        รายงานรายได้ค่าจอดรถรายวัน
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">RPFI01</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Daily Parking Revenue — จาก parking_finance ที่มี transaction
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="rows.length === 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!hasSearched() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'ดูแบบ PDF' }}
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4 no-print">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">local_parking</span>
          เงื่อนไขรายงาน
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน
      </div>

      <div class="flex flex-col xl:flex-row xl:items-end gap-3 max-w-5xl">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3 flex-1">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #startDatePicker type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
                [max]="endDate || undefined" (click)="startDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ถึงวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #endDatePicker type="date" [(ngModel)]="endDate" (ngModelChange)="onFilterChange()"
                [min]="startDate || undefined" [max]="maxEndDate" (click)="endDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
          <div class="relative" (click)="$event.stopPropagation()">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              ประเภทรถ <span class="normal-case font-medium text-slate-400">(ไม่บังคับ)</span>
            </label>
            <div
              class="relative flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">directions_car</span>
              <input type="text" [(ngModel)]="searchVehicleTypeText"
                [disabled]="isLoadingVehicleTypes()"
                (focus)="isVehicleTypeDropdownOpen = true"
                (blur)="closeDropdowns()"
                placeholder="ทุกประเภท — หรือพิมพ์เพื่อเลือก"
                class="w-full h-full pl-10 pr-10 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
              <button type="button"
                (click)="isVehicleTypeDropdownOpen = !isVehicleTypeDropdownOpen; $event.stopPropagation()"
                [disabled]="isLoadingVehicleTypes()"
                class="absolute right-2 text-slate-400 border-none bg-transparent cursor-pointer disabled:opacity-50">
                <span class="material-icons text-lg" [class.rotate-180]="isVehicleTypeDropdownOpen">expand_more</span>
              </button>
            </div>
            <div *ngIf="isVehicleTypeDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute z-40 mt-2 w-full max-h-56 overflow-y-auto custom-scrollbar bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-700 py-2">
              <button type="button" (click)="clearVehicleType()"
                class="w-full text-left px-4 py-2.5 text-sm font-bold border-none bg-transparent cursor-pointer hover:bg-amber-50 dark:hover:bg-slate-700/50"
                [ngClass]="!vehicleTypeId ? 'text-amber-600 bg-amber-50/60' : 'text-slate-500'">
                ทุกประเภท
              </button>
              <button *ngFor="let opt of filteredVehicleTypes" type="button" (click)="selectVehicleType(opt)"
                class="w-full text-left px-4 py-2.5 text-sm font-medium border-none bg-transparent cursor-pointer hover:bg-amber-50 dark:hover:bg-slate-700/50"
                [ngClass]="vehicleTypeId === opt.id ? 'text-amber-600 bg-amber-50/60' : 'text-slate-700 dark:text-slate-200'">
                {{ opt.typeName }}
              </button>
            </div>
          </div>
        </div>
        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 shrink-0 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">search</span>
          {{ isLoading() ? 'กำลังค้นหา...' : 'ค้นหา' }}
        </button>
      </div>
      <p class="text-[11px] text-slate-400 font-medium">ช่วงวันที่สูงสุด 2 เดือน · เฉพาะรายการที่มี transaction · ไม่รวมคอลัมน์ประเภท / ตราประทับ / ค้างคืน</p>
    </div>

    <div class="overflow-x-auto min-h-[280px] relative custom-scrollbar p-4 md:p-6 space-y-4">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

      <div *ngIf="!isLoading() && !hasSearched()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search</span>
        <p class="font-bold">เลือกเงื่อนไข แล้วกดค้นหา</p>
      </div>

      <div *ngIf="!isLoading() && hasSearched() && rows.length === 0" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">inbox</span>
        <p class="font-bold">ไม่พบข้อมูลในช่วงที่เลือก</p>
      </div>

      <table *ngIf="!isLoading() && rows.length > 0" class="w-full text-left border-collapse min-w-[1200px] text-xs">
        <thead class="bg-white/95 dark:bg-slate-800/95">
          <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider text-center whitespace-nowrap">
            <th class="p-2 border border-slate-100 dark:border-slate-700">ลำดับ</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700">เลขใบเสร็จ</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700">ทะเบียน</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700">วัน-เวลา เข้า</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700">วัน-เวลา ชำระ</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ยกออก</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">เงินสด</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">QR</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700">ชม.ปกติ</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ก่อน VAT</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ภาษี</th>
            <th class="p-2 border border-slate-100 dark:border-slate-700 text-right">ยอดสุทธิ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 tabular-nums">
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ r.seq }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 font-mono">{{ r.receiptId }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 font-semibold">{{ r.entryLicense }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 whitespace-nowrap">{{ formatDateTime(r.entryDate) }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 whitespace-nowrap">{{ formatDateTime(r.paidDate) }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.manualExit | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.cash | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.qr | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ r.durationText }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.fee | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right">{{ r.vat | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-50 dark:border-slate-700 text-right font-bold">{{ r.total | number:'1.2-2' }}</td>
          </tr>
        </tbody>
        <tfoot *ngIf="totals">
          <tr class="bg-amber-50/60 dark:bg-amber-950/20 font-bold tabular-nums">
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right" colspan="5">
              สรุป {{ totals.rowCount | number }} รายการ
            </td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ totals.sumManualExit | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ totals.sumCash | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ totals.sumQr | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700"></td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ totals.sumFee | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ totals.sumVat | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right text-amber-700 dark:text-amber-300">{{ totals.sumTotal | number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'RPFI01 — รายงานรายได้ค่าจอดรถรายวัน (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>
